/**
 * Restore '+' characters in an email read from URLSearchParams.
 *
 * URLSearchParams decodes '+' as a space (per the application/x-www-form-urlencoded spec).
 * Email aliases like "user+tag@gmail.com" arrive as "user tag@gmail.com".
 * This function reverses that decoding so the email is usable.
 */
export function restoreEmailPlus(raw: string): string {
  return raw.replace(/ /g, '+');
}
